/**
 * @function axiosRequestSafeConfig
 * @description Sets the default, safe axios Request Config.
 * @param config - Axios request config.
 * @returns {object} Axios request config with safe default settings.
 */
const axiosRequestSafeConfig = async config => ({
  ...config,
  // axios (at least 1.5.1) has potential for a High CSRF vuln if withCredentials=true
  withCredentials: false,
});

export default axiosRequestSafeConfig;
